import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader/loader.service';

// Header custom per escludere il loader da specifiche chiamate
export const SKIP_LOADER_HEADER = 'X-Skip-Loader';

/**
 * Intercetta tutte le richieste HTTP e mostra/nasconde il loader.
 *
 * Per disabilitare il loader:
 * const headers = new HttpHeaders().set(SKIP_LOADER_HEADER, 'true');
 * this.http.get('url', { headers });
 */
export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  // Controlla se la richiesta ha l'header per saltare il loader
  const skipLoader = req.headers.has(SKIP_LOADER_HEADER);

  // Rimuove l'header custom prima di inviare la richiesta
  const cleanReq = skipLoader
    ? req.clone({ headers: req.headers.delete(SKIP_LOADER_HEADER) })
    : req;

  // Mostra il loader solo se non è stato richiesto di saltarlo
  if (!skipLoader) {
    loaderService.show();
  }

  return next(cleanReq).pipe(
    finalize(() => {
      if (!skipLoader) {
        loaderService.hide();
      }
    })
  );
};
